import {
    MenuComponent as SourceMenuComponent,
} from 'SourceComponent/Menu/Menu.component';

import './Menu.override.style';
import React from "react";
import { SCROLL_DEBOUNCE_DELAY } from '@scandipwa/scandipwa/src/component/Menu/Menu.config';
import { debounce } from '@scandipwa/scandipwa/src/util/Request/Debounce';
import MenuItem from '@scandipwa/scandipwa/src/component/MenuItem';
import { getSortedItems } from '@scandipwa/scandipwa/src/util/Menu';
import Link from '@scandipwa/scandipwa/src/component/Link';
import SearchField from '../SearchField/SearchField.component';

export class MenuComponent extends SourceMenuComponent {
    static propTypes = {
        searchCriteria: this.propTypes,
        onSearchOutsideClick: this.propTypes,
        onSearchBarFocus: this.propTypes,
        onSearchBarChange: this.propTypes,
        onClearSearchButtonClick: this.propTypes,
        isVisible: this.propTypes,
        isActive: this.propTypes,
        hideActiveOverlay: this.propTypes
    }

    debouncedCloseMenu;

    constructor(props) {
        super(props);

        this.state = {
            menuopen: false,
            id: ""
        }

        this.renderSearchField.bind(this);
    }

    componentDidMount() {
        const { closeMenu } = this.props;

        this.debouncedCloseMenu = debounce(closeMenu, SCROLL_DEBOUNCE_DELAY);

        window.addEventListener('scroll', this.debouncedCloseMenu);
    }

    componentWillUnmount() {
        if (this.debouncedCloseMenu) {
            window.removeEventListener('scroll', this.debouncedCloseMenu);
        }
    }

    renderDesktopSubLevelItems(item) {
        const { item_id } = item;
        const { closeMenu, activeMenuItemsStack } = this.props;

        return (
            <MenuItem
                activeMenuItemsStack={activeMenuItemsStack}
                item={item}
                closeMenu={closeMenu}
                isLink
                key={item_id}
            />
        );
    }

    renderDesktopSubLevel(category) {
        const { device } = this.props;
        const { children, item_id } = category;
        const childrenArray = getSortedItems(Object.values(children));

        if (device.isMobile || !childrenArray.length) {
            return null;
        }

        return (
            <div key={item_id}>
                <div>
                    {childrenArray.map((item) => this.renderDesktopSubLevelItems(item))}
                </div>
            </div>
        );
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    renderSubLevelItems(item, isSecondLevel) {
        const {
            handleSubcategoryClick,
            activeMenuItemsStack,
            onCategoryHover,
            closeMenu,
            device,
        } = this.props;

        const { item_id, children } = item;

        const childrenArray = Object.values(children);
        const subcategoryMods = { type: 'subcategory', isSecondLevel };

        if (childrenArray.length && device.isMobile) {
            return (
                <div
                    key={item_id}
                    onClick={(e) => handleSubcategoryClick(e, item)}
                    tabIndex={0}
                    role="button"
                >
                    <MenuItem
                        activeMenuItemsStack={activeMenuItemsStack}
                        item={item}
                        itemMods={{ ...subcategoryMods, isExpanded: activeMenuItemsStack.includes(item_id) }}
                        onCategoryHover={onCategoryHover}
                        closeMenu={closeMenu}
                        isExpandable
                    />
                    {this.renderSubLevel(item)}
                </div>
            );
        }

        return (
            <div
                key={item_id}
                onClick={this.stopPropagation}
                role="button"
                tabIndex={-1}
            >
                <MenuItem
                    activeMenuItemsStack={activeMenuItemsStack}
                    item={item}
                    itemMods={subcategoryMods}
                    closeMenu={closeMenu}
                    isLink
                />
                {this.renderDesktopSubLevel(item)}
            </div>
        );
    }

    renderSubLevel(category, isSecondLevel = false) {
        const { activeMenuItemsStack, device } = this.props;
        const { item_id, children, title } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };
        const categorytitle = title.replaceAll(" ", "_");

        return (
            <div key={item_id} className={isVisible ? `Menu-SubMenu Menu-SubMenu_isVisible ${categorytitle}` : `Menu-SubMenu ${categorytitle}`}>
                <div className='Menu-ItemList Menu-ItemList_type_subcategory'>
                    {/* {device.isMobile && (
                        <MenuItem
                            activeMenuItemsStack={activeMenuItemsStack}
                            item={{ ...category, title: `All ${title}` }}
                            itemMods={{ ...subcategoryMods, isSecondLevel }}
                            isLink
                        />
                   )} */}
                    {childrenArray.map((item) => this.renderSubLevelItems(item, isSecondLevel))}
                </div>
            </div>
        );
    }

    renderSubMenuDesktopItems(item) {
        const { item_id, children } = item;

        if (!Object.keys(children).length) {
            return null;
        }

        const { activeMenuItemsStack, closeMenu } = this.props;
        const isVisible = activeMenuItemsStack.includes(item_id);

        if (!isVisible) {
            return null;
        }

        return (
            <div key={item_id}>
                <div>
                    <div>
                        {this.renderSubLevel(item)}
                    </div>
                </div>
                <div onMouseEnter={closeMenu} />
            </div>
        );
    }

    renderSubMenuDesktop(itemList) {
        const { device } = this.props;

        if (device.isMobile) {
            return null;
        }

        const childrenArray = getSortedItems(Object.values(itemList));

        return childrenArray.map(this.renderSubMenuDesktopItems.bind(this));
    }

    renderFirstLevelItems(item) {
        const {
            activeMenuItemsStack,
            handleSubcategoryClick,
            onCategoryHover,
            closeMenu,
            device,
        } = this.props;

        const { children, item_id } = item;
        const childrenArray = Object.values(children);
        const itemMods = { type: 'main' };

        if (childrenArray.length && device.isMobile) {
            return (
                <div
                    className='Menu-SubCatLink'
                    onClick={(e) => handleSubcategoryClick(e, item)}
                    tabIndex={0}
                >
                    <MenuItem
                        activeMenuItemsStack={activeMenuItemsStack}
                        item={item}
                        itemMods={{ ...itemMods, isExpanded: activeMenuItemsStack.includes(item_id) }}
                        onCategoryHover={onCategoryHover}
                        closeMenu={closeMenu}
                        isExpandable
                    />
                    {this.renderSubLevel(item, true)}
                </div>
            );
        }

        return (
            <MenuItem
                activeMenuItemsStack={activeMenuItemsStack}
                item={item}
                itemMods={itemMods}
                onCategoryHover={onCategoryHover}
                closeMenu={closeMenu}
                isLink
            />
        );
    }

    rendersubchildrenelement(value) {
        const childrenArray = Object.values(value.children);

        return (
            <ul className='menu-subcategory-list'>
                {
                    childrenArray?.map((list, i) => (
                        <li key={i}>
                            <Link
                                to={list.url.pathname}
                                onClick={() => this.setState({ menuopen: false, id: "" })}
                            >
                                {list.icon ? <img src={`/media/${list.icon}`} /> : ""}
                                <span>{list.title}</span>
                            </Link>
                        </li>
                    ))
                }
            </ul>
        );
    }

    renderchildrenelement(item) {
        const childrenArray = Object.values(item.children);

        if (childrenArray.length <= 0) {
            return null;
        }

        const menuopen_classname = this.state.id === item.item_id && this.state.menuopen ? "menu-items-list_open" : "";

        return (
            <div className={`menu-items-list ${menuopen_classname}`}>
                {
                    childrenArray?.map((value, index) => (
                        <div className='menu-subcategoris-container' key={index}>
                            {
                                value.labelwithimage !== null ?
                                    <img className='category-image' src={`/media/${value.labelwithimage}`} /> :
                                    <span className='menu-categories-title'>{value.title}</span>
                            }
                            <div>
                                {this.rendersubchildrenelement(value)}
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    renderFirstLevel(item) {
        const { item_id } = item;

        return (
            <li
                key={item_id}
                className='Menu-Item'
                onMouseEnter={() => this.setState({ menuopen: true, id: item_id })}
                onMouseLeave={() => this.setState({ menuopen: false, id: "" })}
            >
                {this.renderFirstLevelItems.call(this, item)}
                {this.renderchildrenelement(item)}
            </li>
        );
    }

    renderSearchField = () => {
        const {
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            isActive,
            isCheckout,
            hideActiveOverlay,
            isVisible,
            device
        } = this.props;

        if (device?.isMobile) {
            return null;
        }

        return (
            <SearchField
                key="search"
                searchCriteria={searchCriteria}
                onSearchOutsideClick={onSearchOutsideClick}
                onSearchBarFocus={onSearchBarFocus}
                onSearchBarChange={onSearchBarChange}
                onClearSearchButtonClick={onClearSearchButtonClick}
                isVisible={isVisible}
                isActive={isActive}
                hideActiveOverlay={hideActiveOverlay}
                device={device}
            />
        );
    }

    renderTopLevel(closeMenu) {
        const { menu } = this.props;
        const categoryArray = Object.values(menu);

        if (!categoryArray.length) {
            return <div />;
        }

        const [{ children, title: mainCategoriesTitle }] = categoryArray;
        const childrenArray = getSortedItems(Object.values(categoryArray));

        return (
            <>
                <div onMouseLeave={closeMenu} className='Menu-MenuWrapper'>
                    <div className='Menu-MainCategories'>
                        <ul aria-label={mainCategoriesTitle} className='Menu-ItemList Menu-ItemList_type_main'>
                            {childrenArray.map(this.renderFirstLevel.bind(this))}
                        </ul>
                        {this.renderSearchField()}
                    </div>
                </div>
                {this.renderSubMenuDesktop(children)}
            </>
        );
    }

    render() {
        const { closeMenu } = this.props;

        return (
            <>
                {this.renderTopLevel(closeMenu)}
            </>
        );
    }
}

export default MenuComponent;
